import { get } from 'lodash-es';

import type { WizardOpenConfig } from '../ltl.types';

type LtlCoreState = {
  isWizardOpen: boolean;
  wizardOpenConfig: WizardOpenConfig | null;
  isDownloadingDocument: boolean;
  isFulfillmentTypeChanging: boolean;
  hasFulfillmentTypeError: boolean;
};

export const selectIsWizardOpen = (state: LtlCoreState): boolean => get(state, 'isWizardOpen', false);
export const selectWizardOpenConfig = (state: LtlCoreState): WizardOpenConfig | null => get(state, 'wizardOpenConfig', null);
export const selectIsDownloadingDocument = (state: LtlCoreState): boolean => get(state, 'isDownloadingDocument', false);
export const selectIsFulfillmentTypeChanging = (state: LtlCoreState): boolean => get(state, 'isFulfillmentTypeChanging', false);
export const selectHasFulfillmentTypeError = (state: LtlCoreState): boolean => get(state, 'hasFulfillmentTypeError', false);
